import React from 'react';
import './Industries.css';

const Industries = () => {
  const industries = [
    {
      name: 'Automotive',
      description: 'Automation solutions for automotive manufacturing including assembly lines, quality control, and material handling systems.',
      applications: [
        'Assembly line automation',
        'Welding and joining systems',
        'Quality inspection',
        'Material handling'
      ]
    },
    {
      name: 'Medical Devices',
      description: 'Precision automation for medical device manufacturing with strict quality and regulatory compliance requirements.',
      applications: [
        'Precision assembly',
        'Clean room automation',
        'Quality validation',
        'Packaging systems'
      ]
    },
    {
      name: 'Consumer Products',
      description: 'High-speed automation for consumer goods manufacturing, packaging, and distribution.',
      applications: [
        'Packaging automation',
        'Filling and capping',
        'Labeling systems',
        'Case packing'
      ]
    },
    {
      name: 'Aerospace',
      description: 'Advanced automation systems for aerospace manufacturing with emphasis on precision and traceability.',
      applications: [
        'Precision machining',
        'Assembly automation',
        'Quality documentation',
        'Material handling'
      ]
    },
    {
      name: 'Electronics',
      description: 'Automation solutions for electronics manufacturing including PCB assembly, testing, and packaging.',
      applications: [
        'PCB assembly',
        'Component placement',
        'Testing and inspection',
        'Packaging automation'
      ]
    },
    {
      name: 'Food & Beverage',
      description: 'Hygienic automation systems for food and beverage processing, packaging, and distribution.',
      applications: [
        'Processing automation',
        'Filling and sealing',
        'Packaging systems',
        'Quality control'
      ]
    }
  ];

  return (
    <div className="industries-page">
      <section className="page-hero">
        <div className="container">
          <h1>Industries We Serve</h1>
          <p className="page-hero-subtitle">
            Specialized automation solutions across diverse manufacturing sectors
          </p>
        </div>
      </section>

      <section className="industries-content">
        <div className="container">
          <div className="industries-intro">
            <p>
              SCE Automated has extensive experience serving manufacturers across 
              multiple industries. Our deep understanding of industry-specific 
              requirements, regulations, and best practices enables us to deliver 
              automation solutions that are both technically advanced and practically 
              applicable to your business.
            </p>
          </div>

          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-card">
                <h2>{industry.name}</h2>
                <p className="industry-description">{industry.description}</p>
                <div className="industry-applications">
                  <h3>Applications:</h3>
                  <ul>
                    {industry.applications.map((app, idx) => (
                      <li key={idx}>{app}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>

          <div className="industries-cta">
            <h2>Not Sure Which Solution Fits Your Industry?</h2>
            <p>Our team can help identify the right automation approach for your specific needs</p>
            <a href="/contact" className="btn btn-primary">Contact Us</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Industries;

